<template>
	<div _flex="~ col" _overflow="hidden" :style="{ height: 'calc(100vh - 100px)' }">
		<div _bg="white" _p="l-25px y-15px r-50px" _pos="relative">
			<div _flex="~ items-center" _text="16px" _cursor="pointer" _hover="text-color-[#ff5e2a]" @click="$router.go(-1)">
				<i class="el-icon-arrow-left" _m="r-5px" style="font-weight: 1000;"></i>返回
			</div>
      <img _pos="absolute" _left="25px" _top="60px" :src="info?.account?.avatar?.url || 'https://file.xinhuomy.com/default.png'" width="72px" height="72px" _border="rounded-900px">
      <div _flex="~ items-center justify-between" _m="l-100px t-30px">
        <div _flex="~ items-center">
          <span _text="[#272727] 18px" style="font-weight: 600;" _m="r-20px">{{ info?.account?.realname }}</span>
          <span _text="[#3E793D]" _flex="~ items-center justify-center" _bg="[#F3FFF4]" _w="78px" _h="32px">{{
            info?.student_state
          }}</span>
        </div>
        <div _flex="~ items-center">
          <svg
            class="icon"
            v-if="info.account != null"
            aria-hidden="true"
            style="width: 23px; height: 23px; outline: none; box-shadow: none;"
          >
            <use v-if="info.account.openid === null" xlink:href="#icon-wechartstate"></use>
            <use v-else xlink:href="#icon-wechartstate2"></use>
          </svg>
          <svg
            class="icon"
            v-else
            aria-hidden="true"
            style="width: 23px; height: 23px; outline: none; box-shadow: none;"
          >
            <use xlink:href="#icon-wechartstate"></use>
          </svg>
        </div>
      </div>
      <div _text="[#8C8C8C]" _m="l-100px y-15px" _flex="~ justify-between" style="min-width: 650px;">
        <div _flex="~ items-center">
          <span _m="r-20px">学籍号&nbsp;{{ info?.account?.serial }}</span>
        </div>
        <div _flex="~ items-center">
          <span _m="r-10px">学校：&nbsp;{{ info?.school?.name }}&nbsp;&nbsp;|</span>
          <span _m="r-10px"
            >辖区：&nbsp;{{
              info?.school?.district_division?.l1_name +
              info.school?.district_division?.l2_name +
              (info?.school?.district_division?.l3_name || '')
            }}&nbsp;&nbsp;|</span
          >
          <!-- <span>班级：&nbsp;{{ `${chineseNumArr[info?.classgrade?.grade_number]}（${info?.classgrade?.seq}）班` }}</span> -->
          <span>班级：&nbsp;{{ info?.classgrade?.class_name }}</span>
        </div>
      </div>
			<el-divider _m="y-25px" />
			<!-- <div _text="20px [#FF5E2A]" style="font-weight: 600;">学生管理</div> -->
		</div>
		<div _flex="~ col 1" _overflow="y-auto">
      <div _h="!60px" style="line-height:60px" _p="x-50px" _flex="~ items-center justify-between" _text="16px" _m="t-20px" _bg="white" v-for="item in classgrade" :key="item.id">
        <!-- <span _text="[#272727]" style="font-weight: 600;">{{ `${chineseNumArr[item.grade_number]}（${item.seq}）班` }}</span> -->
        <span _text="[#272727]" style="font-weight: 600;width:98px">{{ item.class_name }}</span>
        <span _text="[#8C8C8C]">
          <b _text="![#272727]" style="font-weight: 600;">{{ item?.school?.name || item?.school_name }}</b>
        </span>
        <span _text="[#8C8C8C]" v-if="item?.graduation_year">
          <b _text="![#272727]" style="font-weight: 600;">就读时间：</b>{{ `${item?.enroll_year} 至 ${item?.graduation_year}` }}
        </span>
        <span _text="[#8C8C8C]" v-else>
          <b _text="![#272727]" style="font-weight: 600;">就读时间：</b>{{ `${info.updated_at.split('-')[0]}` }}<b style="visibility: hidden">年6-30 至 2023-9月</b>
        </span>
      </div>
		</div>
    <!-- <el-button type="primary" size="medium" _m="!b-10px !auto" _w="!150px" @click="moreClassGrade" v-if="moreVisible">查看过往就读信息</el-button> -->
	</div>
</template>

<script>
export default {
	data() {
		return {
			info: {},
      classgrade: [],
      moreVisible: false,
      chineseNumArr: ['零', '一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '初一', '初二', '初三', '高一', '高二', '高三']
		}
	},
	methods: {
    moreClassGrade() {
      this.moreVisible = false
      this.classgrade = [...this.classgrade, ...this.info.history]
      // this.$message.warning('功能还未完善~等接口')
    }
	},
	async mounted() {
		document.body.style['overflow-y'] = 'hidden'
		const { id } = this.$route.query
    this.info = await this.$api.student.showto(id)
    // if (this.info?.history?.length >= 1) {
    //   this.moreVisible = true
    // } else {
    //   this.moreVisible = false
    // }
    // this.classgrade.push(this.info.classgrade)
    if (this.info.state == 2 || this.info.state == 3) {
      this.classgrade = [...this.info.history]
    } else {
      this.classgrade = [this.info.classgrade, ...this.info.history]
    }
	},
	destroyed() {
		document.body.style['overflow-y'] = 'auto'
	}
}
</script>

<style lang="scss" scoped>
</style>
